module.exports = __webpack_public_path__ + "img/run.7cdb0f62.svg";